import IcRemoveCircle from './IcRemoveCircle'

export default IcRemoveCircle
